// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"Registrations_codeContainer__1SAG55F4_fYBNb6I31Clz4"};